import React from 'react';
import { Skeleton } from '@mui/material';
import { useItem } from '@/hooks/item';
import { ServiceErrorView } from '@/components/atoms/Error';
import BasicInfo from '@/components/organisms/item/BasicInfo';
import Detail from '@/components/organisms/item/Detail';
import Mmao from '@/components/organisms/item/Mmao';
import InternalComment from '@/components/organisms/item/InternalComment';
import Purchase from '@/components/organisms/item/Purchase';
import ShippingStatus from '@/components/organisms/item/ShippingStatus';
import PostalLitigation from '@/components/organisms/item/PostalLitigation';
import ShippingFromAddress from '@/components/organisms/item/ShippingFromAddress';
import Compliance from '@/components/organisms/item/Compliance';
import Relist from '@/components/organisms/item/Relist';
import SellerPayment from '@/components/organisms/item/SellerPayment';
import ReturnToWarehouseSeller from '@/components/organisms/item/ReturnToWarehouseSeller';
import Refund from '@/components/organisms/item/Refund';
import Photos from '@/components/organisms/item/Photos';
import ActionLog from './ActionLog';
import DsaReports from '@/components/organisms/common/DsaReports';

const View: React.FC<{ id: number; sellerId?: number }> = ({ id, sellerId }) => {
  const data = useItem(id);
  return (
    <>
      {data.kind === 'Called' && (
        <Skeleton
          height={100}
          variant="rounded"
        />
      )}
      {data.kind === 'Error' && <ServiceErrorView error={data.error} />}
      {data.kind === 'Loaded' && (
        <>
          {/* @TODO Consider refactor the following component since they have same structures */}
          <BasicInfo item={data.data} sellerId={sellerId} />
          <Detail item={data.data} />
          <Photos item={data.data} />
          <InternalComment item={data.data} />
          <Purchase item={data.data} />
          <ShippingStatus item={data.data} />
          <PostalLitigation item={data.data} />
          <ShippingFromAddress item={data.data} />
          <Compliance item={data.data} />
          <Relist item={data.data} />
          <SellerPayment item={data.data} />
          <ReturnToWarehouseSeller item={data.data} />
          <Refund item={data.data} />
          <Mmao item={data.data} />
          <DsaReports itemId={data.data.productId} />
          <ActionLog
            id={data.data.productId}
            type="product"
          />
        </>
      )}
    </>
  );
};

export default View;
